'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var Checkbox = require('./Checkbox.js');

var Toggle = function (_a) {
    var id = _a.id, size = _a.size, _b = _a.placement, placement = _b === void 0 ? 'end' : _b, labelClassName = _a.labelClassName, props = tslib.__rest(_a, ["id", "size", "placement", "labelClassName"]);
    return (jsxRuntime.jsx(Checkbox.default, tslib.__assign({ type: "switch", id: id, size: size, placement: placement, labelClassName: labelClassName }, props)));
};
Toggle.defaultProps = {
    size: 'large',
    placement: 'end',
    labelClassName: ''
};
var Toggle$1 = Toggle;

exports.default = Toggle$1;
//# sourceMappingURL=Toggle.js.map
